<!-- eslint-disable -->
<template lang="pug">
    div(@mousedown.prevent="")
        datepicker-header(
           :previousTime="previousYear"
           :nextTime="nextYear"
           :showCalendar="showYearCalendar"
           :headerText="pageYearName"
           :clickable="true"
        )
        datepicker-calendar(
            time="Month"
            :items="months"
            :select="selectMonth"
        )
</template>

<script>
    /*eslint-disable*/
    import PickerMonth from "../../../node_modules/vuejs-datepicker/src/components/PickerMonth.vue"
    import DatepickerHeader from "./DatepickerHeader.vue"
    import DatepickerCalendar from "./DatepickerCalendar.vue"

    export default {
        name: "PickerMonth",
        status: "ready",
        release: "1.0.0",
        extends: PickerMonth,
        components: {
            DatepickerHeader,
            DatepickerCalendar,
        },
    }
</script>
